import React, { useMemo } from 'react'
import ElementItem from '../../ElementItem'
import { IssueLevel } from './types'
import styled from 'styled-components'

const Content = styled.div`
  margin-top: 5px;
`

type Props = React.ComponentProps<typeof ElementItem> & {
  level: IssueLevel;
  title: React.ReactNode;
}

const Issue: React.FC<Props> = ({
  children,
  icon,
  level,
  title,
  ...props
}) => {
  const levelClassName = useMemo(() => {
    switch (level as IssueLevel) {
      case 'danger':
        return 'text-danger'
      case 'warning':
        return 'text-warning'
    }
  }, [level])

  return (
    <ElementItem
      {...props}
      icon={
        icon ? (
          <span
            className={levelClassName}
          >
            {icon}
          </span>
        ) : undefined
      }
    >
      <div
        className={levelClassName}
      >
        {title}
      </div>
      {children &&
        <Content>
          {children}
        </Content>
      }
    </ElementItem>
  )
}

export default Issue
